var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"navBar super-sticky pa-0"},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticClass:"px-6",attrs:{"height":"85","data-testid":"navbar"}},[_c('NavLogo'),_vm._v(" "),_c('v-spacer')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }